var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { MessageService } from '@bcone/neo-app-sdk';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Apollo } from 'apollo-angular';
import * as Query from './data-org-queries';
import gql from 'graphql-tag';
var DataOrgService = /** @class */ (function () {
    function DataOrgService(messageService, http, apollo) {
        this.messageService = messageService;
        this.http = http;
        this.apollo = apollo;
        this.environment = this.messageService.getEnv();
    }
    DataOrgService.prototype.getNodes = function (parameters) {
        var api = this.environment.api_url + '/searchtree';
        return this.http.get(api, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json', 'appId': 'neodataplatform',
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': 'Thu, 01 Jan 1970 00:00:00 GMT',
                'If-Modified-Since': '0'
            }),
            params: parameters
        }).pipe(map(function (data) {
            return data;
        }));
    };
    DataOrgService.prototype.getGroupsOnUserIdCmp = function (userId) {
        var query = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["query getGroupsOnUserId($userId: UUID!, $markForDeletion: Boolean) {\n            sysUserGroupMappings(condition: {userId: $userId, markForDeletion: $markForDeletion}) {\n                nodes {\n                  groupId\n                }\n            }\n          }"], ["query getGroupsOnUserId($userId: UUID!, $markForDeletion: Boolean) {\n            sysUserGroupMappings(condition: {userId: $userId, markForDeletion: $markForDeletion}) {\n                nodes {\n                  groupId\n                }\n            }\n          }"])));
        return this.apollo.watchQuery({
            query: query,
            fetchPolicy: 'no-cache',
            variables: {
                userId: userId,
                markForDeletion: false
            }
        }).valueChanges.pipe(map(function (resData) { return resData.data; }));
    };
    DataOrgService.prototype.getPoliciesOnDataOrgIdCmp = function (dataOrgNodeId) {
        var query = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["query getPoliciesOndataOrgId($dataOrgNodeId: UUID!, $markForDeletion: Boolean) {\n            sysPolicies(filter: {dataOrgFileId: {isNull: true}, dataOrgNodeId: {equalTo: $dataOrgNodeId},\n                markForDeletion: {equalTo: $markForDeletion}}) {\n            nodes {\n              applyForChildNodes\n              policyId\n              sysPolicyUserGroupMappingsByPolicyId {\n                nodes {\n                  groupId\n                  privileges\n                }\n              }\n            }\n          }\n        }"], ["query getPoliciesOndataOrgId($dataOrgNodeId: UUID!, $markForDeletion: Boolean) {\n            sysPolicies(filter: {dataOrgFileId: {isNull: true}, dataOrgNodeId: {equalTo: $dataOrgNodeId},\n                markForDeletion: {equalTo: $markForDeletion}}) {\n            nodes {\n              applyForChildNodes\n              policyId\n              sysPolicyUserGroupMappingsByPolicyId {\n                nodes {\n                  groupId\n                  privileges\n                }\n              }\n            }\n          }\n        }"])));
        return this.apollo.watchQuery({
            query: query,
            fetchPolicy: 'no-cache',
            variables: {
                dataOrgNodeId: dataOrgNodeId,
                markForDeletion: false
            }
        }).valueChanges.pipe(map(function (resData) { return resData.data; }));
    };
    DataOrgService.prototype.readDataByDataOrgNodeId = function (id, type) {
        return this.apollo.watchQuery({
            query: Query.readFilesQuery,
            fetchPolicy: 'no-cache',
            variables: {
                dataOrgNodeId: id
            }
        }).valueChanges.pipe(map(function (resData) { return resData; }));
    };
    return DataOrgService;
}());
export { DataOrgService };
var templateObject_1, templateObject_2;
